export function getDailyCustOption(data: any) {
  return {
    dataset: [
      {
        id: 'dataset_raw',
        source: data
      }
    ],
    legend: {
      top: 10
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        align: 'left'
      }
    },
    xAxis: {
      type: 'category',
      nameLocation: 'middle'
    },
    dataZoom: [
      {
        type: 'slider',
        show: true,
        xAxisIndex: [0],
        start: 100 - (30 / data.length) * 100,
        end: 100
      }
    ],
    yAxis: {},
    series: [
      {
        name: '介绍服务',
        type: 'line',
        datasetId: 'dataset_raw',
        showSymbol: false,
        encode: {
          x: 'fillDateFormat',
          y: 'introduceService',
          itemName: 'fillDateFormat',
          tooltip: ['introduceService']
        }
      },
      {
        name: '报价',
        type: 'line',
        datasetId: 'dataset_raw',
        showSymbol: false,
        encode: {
          x: 'fillDateFormat',
          y: 'quotedPrice',
          itemName: 'fillDateFormat',
          tooltip: ['quotedPrice']
        }
      },
      {
        name: '回复率',
        type: 'line',
        datasetId: 'dataset_raw',
        showSymbol: false,
        encode: {
          x: 'fillDateFormat',
          y: 'replyRate',
          itemName: 'fillDateFormat',
          tooltip: ['replyRate']
        }
      },
      {
        name: '10万以上直播数量',
        type: 'line',
        datasetId: 'dataset_raw',
        showSymbol: false,
        encode: {
          x: 'fillDateFormat',
          y: 'hundredThousandLiveData',
          itemName: 'fillDateFormat',
          tooltip: ['hundredThousandLiveData']
        }
      }
    ]
  }
}
